export const getCarriers = state => state.carrierSelector.carrier.nodes;
export const getCheckedCarriers = state => state.carrierSelector.carrier.checkedCarriers;

export const getSelectedCarriers = state =>
  (state.carrierSelector.carrier.nodes || []).filter(node =>
    getCheckedCarriers(state).includes(node.value));

export const getCheckedCarrierLabels = state =>
  getSelectedCarriers(state).map(node => node.iataCode);

export const getCarrierIsLoading = state => state.carrierSelector.carrier.isLoading;
